import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonModalComponent } from '@shared/components/common-modal/common-modal.component';
import { ModalResponseEnum } from '@shared/enums/modal-response.enum';

@Component({
  selector: 'app-mobile-device-warning',
  imports: [CommonModalComponent, MatButtonModule],
  templateUrl: './mobile-device-warning.component.html',
  styleUrl: './mobile-device-warning.component.scss',
})
export class MobileDeviceWarningComponent implements OnInit {
  private dialogRef = inject(MatDialogRef<MobileDeviceWarningComponent>);

  ngOnInit(): void {
    this.dialogRef.afterClosed().subscribe({
      next: (response) => {
        if (
          !response?.['event'] ||
          response?.['event'] === ModalResponseEnum.CANCEL
        ) {
          window.location.reload();
        }
      },
    });
  }

  onCancel() {
    this.dialogRef.close({ event: ModalResponseEnum.CANCEL });
  }
}
